import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';

interface SearchFieldWrapperProps {
  children: ReactNode;
  paddingInline?: number;
  sx?: SxProps<Theme>;
}

const SearchFieldWrapper = ({ children, paddingInline = 0, sx }: SearchFieldWrapperProps) => {
  return (
    <Box
      sx={[
        {
          paddingX: paddingInline,
          paddingBottom: 1 / 2,
          paddingTop: 1,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
};

export default SearchFieldWrapper;
